export const useStoreEvent = defineStore('StoreEvent', {
    state: () => ({
        item: null,
        disabled: null,
        error: null,
    }),
    actions: {
        async getEvent(idEvent) {
            this.error = null;
            if (this.item?.id_event !== parseInt(idEvent)) {
                this.item = null;
            }
            ({event: this.item, error: this.error} = await useEntityEvent().get(idEvent));
        },
        updateEventField({field, value}) {
            if (this.item[field] === undefined)
                throw new Error('Attempted to update an event field which does not exist (' + field + ').');
            this.item[field] = value;
        },
        async putEvent() {
            this.error = null;
            this.disabled = true;
            ({event: this.item, error: this.error} = await useEntityEvent().put(this.item.id_event, this.item));
            this.disabled = false;
        },
        async deleteEvent() {
            this.error = null;
            ({error: this.error} = await useEntityEvent().remove(this.item.id_event));
            if (this.error) return;
            await navigateTo('/events');
        },
        clearError() {
            this.error = null;
        },
    },
});
